import React, { useState } from "react";
import { Tabs, Tab, Button, IconButton, Skeleton, MenuItem, Select, FormControl } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import "./TheStudentDashboard.css";
import { history } from "../../../../../../helper/history";
import { routes } from "../../../../../../helper/routes";
import Papers from './imageFiles/Papers.png';
import CustomGradeDropdown from "./CustomGradeDropdown ";
const PaperDetails = ({ availablePapers, enrolledPapers, completedPapers, student_dashboard_initial_loading }) => {

  const [tabIndex, setTabIndex] = useState(0);
  const [grade, setGrade] = useState("All");

  const handleChangeGrade = (event) => {
    setGrade(event.target.value);
  };

  const skeletonPapers = Array(5).fill({});

  const handleOnClickEnrol = () => {
    history.push(routes.find_papers)
  }

  return (
    <div className="paper-details-box">
      <div className="paper-details-topBar">
        <div>&emsp;</div>
        <div>
          <Tabs
            value={tabIndex}
            onChange={(e, val) => setTabIndex(val)}
            className="paper-tabs"
            TabIndicatorProps={{ style: { backgroundColor: '#8D4ED3' } }}
          >
            <Tab label="Available" />
            <Tab label="Enrolled" />
            <Tab label="Completed" />
          </Tabs>
        </div>
        <div>
          {/* <CustomGradeDropdown grade={grade} setGrade={setGrade} /> */}

        </div>
      </div>
      {student_dashboard_initial_loading ? (

        <div className="paper-list">
          {skeletonPapers.map((_, index) => (
            <div className="paper-row" key={`skeleton-${index}`}>
              <div className="paper-info">
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  className="paper-icon"
                  animation="pulse"
                />
                <div className="paper-text">
                  <Skeleton variant="text" width={250} height={24} />
                  <Skeleton variant="text" width={130} height={24} />
                  <Skeleton variant="text" width={100} height={20} />
                  <Skeleton variant="text" width={80} height={20} />
                </div>
              </div>
              <div className="paper-actions">
                <Skeleton variant="rounded" width={80} height={36} animation="pulse" />
                <Skeleton variant="circular" width={36} height={36} />
              </div>
            </div>
          ))}
        </div>

      ) : (
        <>
          {tabIndex === 0 && (
            <div className="paper-list">
              {availablePapers?.map((paper, index) => (
                <div className="paper-row" key={index}>
                  <div className="paper-info col-12 px-0">
                    <div className="paper-info col-md-5 px-0">
                      <img src={Papers} alt="icon" className="paper-icon" />
                      <p className="subject">{paper.assess_name}</p>
                    </div>
                    <div className="paper-text col-md-7 px-0">
                      <div className="col-md-4 px-0">
                        <p className="subject">{paper.subject_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">{paper.language_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">Grade {paper.grade_name || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {tabIndex === 1 && (
            <div className="paper-list">
              {enrolledPapers?.map((enrolled_paper, index) => (
                <div className="paper-row" key={index}>
                  <div className="paper-info col-12 px-0">
                    <div className="paper-info col-md-5 px-0">
                      <img src={Papers} alt="icon" className="paper-icon" />
                      <p className="subject">{enrolled_paper.assess_name}</p>
                    </div>
                    <div className="paper-text col-md-7 px-0">
                      <div className="col-md-4 px-0">
                        <p className="subject">{enrolled_paper.subject_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">{enrolled_paper.language_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">Grade {enrolled_paper.grade_name || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {tabIndex === 2 && (
            <div className="paper-list">
              {completedPapers?.map((completed_paper, index) => (
                <div className="paper-row" key={index}>
                  <div className="paper-info col-12 px-0">
                    <div className="paper-info col-md-5 px-0">
                      <img src={Papers} alt="icon" className="paper-icon" />
                      <p className="subject">{completed_paper.assess_name}</p>
                    </div>
                    <div className="paper-text col-md-7 px-0">
                      <div className="col-md-4 px-0">
                        <p className="subject">{completed_paper.subject_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">{completed_paper.language_name || "N/A"}</p>
                      </div>
                      <div className="col-md-4 px-0">
                        <p className="language">Grade {completed_paper.grade_name || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaperDetails;
